"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRegionalPathname = exports.getSitePrefix = exports.getApiHost = void 0;
var get_api_host_1 = require("./get-api-host");
Object.defineProperty(exports, "getApiHost", { enumerable: true, get: function () { return get_api_host_1.getApiHost; } });
var get_site_prefix_1 = require("./get-site-prefix");
Object.defineProperty(exports, "getSitePrefix", { enumerable: true, get: function () { return get_site_prefix_1.getSitePrefix; } });
var parse_regional_pathname_1 = require("./parse-regional-pathname");
Object.defineProperty(exports, "parseRegionalPathname", { enumerable: true, get: function () { return parse_regional_pathname_1.parseRegionalPathname; } });
//# sourceMappingURL=index.js.map